//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const stringOptions = [
  'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
  ].reduce((acc, opt) => {
  for (let i = 1; i <= 5; i++) {
    acc.push(opt + ' ' + i)
  }
  return acc
}, [])

export default {
    data () {
        return {
            lihatpekerjaan : false,
            modul:'f_pencatatan_perceraian',
            shape: '', 
            current: 3, 
            options: stringOptions,
            dense:true, 
            list_anggota_keluarga:[],
            data: null,
            datas:[],

            je_pekerjaan:[
                {no: '1', jen: 'Belum/Tidak Bekerja'},
                {no: '2', jen: 'Mengurus Rumah Tangga'},
                {no: '3', jen: ' '},
                {no: '4', jen: ' '},
                {no: '5', jen: ' '},
                {no: '6', jen: ' '},
                {no: '7', jen: ' '},
                {no: '8', jen: ' '},
                {no: '9', jen: ' '},
                {no: '10', jen: ' '},
                {no: '11', jen: ' '},
                {no: '12', jen: ' '},
                {no: '13', jen: ' '},
                {no: '14', jen: ' '},
                {no: '15', jen: ' '},
                {no: '16', jen: ' '},
                {no: '17', jen: ' '},
                {no: '18', jen: ' '},
                {no: '19', jen: ' '},
                {no: '20', jen: ' '},
                {no: '21', jen: ' '},
                {no: '22', jen: ' '},
                {no: '23', jen: ' '},
                {no: '24', jen: ' '},
                {no: '25', jen: ' '},
                {no: '26', jen: ' '},
                {no: '27', jen: ' '},
                {no: '28', jen: ' '},
                {no: '29', jen: ' '},
                {no: '30', jen: ' '},
                {no: '31', jen: ' '},
                {no: '32', jen: ' '},
                {no: '33', jen: ' '},
                {no: '34', jen: ' '},
                {no: '35', jen: ' '},
                {no: '36', jen: ' '},
                {no: '37', jen: ' '},
                {no: '38', jen: ' '},
                {no: '39', jen: ' '},
                {no: '40', jen: ' '},
                {no: '41', jen: ' '},
                {no: '42', jen: ' '},
                {no: '43', jen: ' '},
                {no: '44', jen: ' '},
                {no: '45', jen: ' '},
                {no: '46', jen: ' '},
                {no: '47', jen: ' '},
                {no: '48', jen: ' '},
                {no: '49', jen: ' '},
                {no: '50', jen: ' '},
                {no: '51', jen: ' '},
                {no: '52', jen: ' '},
                {no: '53', jen: ' '},
                {no: '54', jen: ' '},
                {no: '55', jen: ' '},
                {no: '56', jen: ' '},
                {no: '57', jen: ' '},
                {no: '58', jen: ' '},
                {no: '59', jen: ' '},
                {no: '60', jen: ' '},
                {no: '61', jen: ' '},
                {no: '62', jen: ' '},
                {no: '63', jen: ' '},
                {no: '64', jen: ' '},
                {no: '65', jen: ' '},
                {no: '66', jen: ' '},
                {no: '67', jen: ' '},
                {no: '68', jen: ' '},
                {no: '69', jen: ' '},
                {no: '70', jen: ' '},
                {no: '71', jen: ' '},
                {no: '72', jen: ' '},
                {no: '73', jen: ' '},
                {no: '74', jen: ' '},
                {no: '75', jen: ' '},
                {no: '76', jen: ' '},
                {no: '77', jen: ' '},
                {no: '78', jen: ' '},
                {no: '79', jen: ' '},
                {no: '80', jen: ' '},
                {no: '81', jen: ' '},
                {no: '82', jen: ' '},
                {no: '83', jen: ' '},
                {no: '84', jen: ' '},
                {no: '85', jen: ' '},
                {no: '86', jen: ' '},
                {no: '87', jen: ' '},
                {no: '88', jen: ' '},
                {no: '89', jen: 'Lainnya'},
            ],

            anggota_keluarga: [
              {
                no_kk:'123456789', 
                nama:'Fajar Syahputra'
              },
              {
                no_kk:'346808425', 
                nama:'Hidayat Darmawan'
              },
            ],

            index : 0,
        }
    },
    methods: {
    get_modal_edit_anggota_keluarga(data, index){
        this.$store.state.modal_edit_anggota_keluarga = true
        this.$store.state.form.keluarga_yg_pindah.nik = data.nik
        this.$store.state.form.keluarga_yg_pindah.nama = data.nama
        this.$store.state.form.keluarga_yg_pindah.masa_berlaku_ktp_dari = data.masa_berlaku_ktp_dari
        this.$store.state.form.keluarga_yg_pindah.masa_berlaku_ktp_hingga = data.masa_berlaku_ktp_hingga
        this.$store.state.form.keluarga_yg_pindah.shdk = data.shdk
        this.index = index;

        console.log("Muncul Modal Dengan index = " + index);
        // nik,  nama,  masa_berlaku_ktp_dari,  masa_berlaku_ktp_hingga,  shdk
         
    },

      addAnggotaKeluarga(){
        this.$store.commit('addanggota_keluarga');
      },

      tambah_keluarga_yg_pindah(){
        this.$store.commit('add_keluarga_yg_pindah');
      },
      edit_modal_edit_anggota_keluarga(index){
        //   this.$store.state.form.keluarga_yg_pindah.nik = nik
        //     this.$store.commit('update');
        var baru = this.index          
        
        this.$store.state.form.list_keluarga_yg_pindah[baru] = {
            nik : this.$store.state.form.keluarga_yg_pindah.nik,
            nama: this.$store.state.form.keluarga_yg_pindah.nama  ,
            masa_berlaku_ktp_dari: this.$store.state.form.keluarga_yg_pindah.masa_berlaku_ktp_dari,
            masa_berlaku_ktp_hingga : this.$store.state.form.keluarga_yg_pindah.masa_berlaku_ktp_hingga,
            shdk: this.$store.state.form.keluarga_yg_pindah.shdk
        }
        console.log("Modal edit = " + baru);

      },

      // load_data(){
      //   this.$store.state.anggota_keluarga = this.list_anggota_keluarga

      // },

      filterFn (val, update, abort) {
        // call abort() at any time if you can't retrieve data somehow
        setTimeout(() => {
          update(
            () => {
              if (val === '') {
                this.options = stringOptions
              }
              else {
                const needle = val.toLowerCase()
                this.options = stringOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
              }
            },

            // next function is available in Quasar v1.7.4+;
            // "ref" is the Vue reference to the QSelect
            ref => {
              if (val !== '' && ref.options.length > 0) {
                ref.setOptionIndex(-1) // reset optionIndex in case there is something selected
                ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
              }
            }
          )
        }, 300)
      },      
      abortFilterFn () {
        // console.log('delayed filter aborted')
      },
      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
            return `${filesNumber} files of ${maxFiles} | ${totalSize}`
          },

    // getView: function() {
    //   fetch(this.anggota_keluarga, {
    //     method: "POST",
    //     headers: {
    //       "content-type": "application/json", 
    //     },
    //     body: JSON.stringify({ 
    //     })
    //   })
    //     .then(res => res.json())
    //     .then(res_data => {
    //       // this.list_data = res_data.data;
    //       // this.page_last = res_data.jml_data;
    //         console.log('thisview' + res_data);
    //     });
    // },
          

    },
    mounted(){
      // this.load_data()
      // this.getView()
      // console.log((this.anggota_keluarga));
      
    }
}
